module.exports = __webpack_public_path__ + "assets/ig-avatar.0787a971.svg";